export default {
  title: 'Something went wrong',
  text: "The system cannot process your request yet. Don't worry, we will fix it as soon as possible",
  checkNetworkConnect: 'Please check your network connection and try refreshing the page',
  hint: 'Try to come back a little later or go to the main page',
  refreshPage: 'Refresh the page',
};
